import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '@tech-services/common.service';
import { LocalStorageKey, SessionService } from '@tech-services/session.service';
import { AppConfig } from './utils/app-config.service';
import { registerLocaleData } from '@angular/common';
import localeMx from '@angular/common/locales/es-MX';

registerLocaleData(localeMx, 'es-MX');

@Component({
  selector: 'thr-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  activeLang = 'en-GB';
  private scrWidth: number;
  private readonly publicRoutePrefixes = [
    '/login',
    '/signup',
    '/recover-password',
    '/resetpassword',
    '/register',
    '/agentaccess',
    '/onboarding',
    '/publicplanner',
  ];

  previousUrl: string = null;
  currentUrl: string = null;

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrWidth = event.target.innerWidth;
    if (this.scrWidth > 992) {
      this.commonService.isMovilSource.next(false);
    } else {
      this.commonService.isMovilSource.next(true);
      this.commonService.menuOpen = false;
    }
  }

  constructor(
    public commonService: CommonService,
    private translate: TranslateService,
    private session: SessionService,
    private router: Router,
    private activatedRouter: ActivatedRoute
  ) {
    this.activeLang = this.session.language;
    this.translate.setDefaultLang(this.activeLang);
    this.translate.use(this.activeLang);

    this.scrWidth = window.innerWidth;
    if (this.scrWidth > 992) {
      this.commonService.isMovilSource.next(false);
    } else {
      this.commonService.isMovilSource.next(true);
      this.commonService.menuOpen = false;
    }

    this.activatedRouter.fragment.subscribe((fragment) => {
      document.querySelector('html').scrollTop = 0;
      if (fragment !== null) {
        this.commonService.jumpTo(fragment);
      }
    }).unsubscribe;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        if (this.shouldHideEvaOnRoute(event.urlAfterRedirects || event.url)) {
          this.commonService.cleanupEvaChat();
        }
      });

    if (this.shouldHideEvaOnRoute(this.router.url || '')) {
      this.commonService.cleanupEvaChat();
    }
    this.loadTheme();
    this.loadHeadImgs();
    this.changeCssColorVar();
  }

  private loadHeadImgs() {
    let link = document.createElement('link');
    let link2 = document.createElement('link');
    let link3 = document.createElement('link');
    let link4 = document.createElement('link');
    let link5 = document.createElement('link');
    let link6 = document.createElement('link');
    let link7 = document.createElement('link');
    let link8 = document.createElement('link');
    link.setAttribute(
      'href',
      './assets/img/' + localStorage.getItem('ThemeImg') + '/LogoW/Logo_W_ico.png'
    );
    link.setAttribute('rel', 'icon');
    link.setAttribute('type', 'image/x-icon');
    document.head.appendChild(link);
    link2.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_120x120.png'
    );
    link2.setAttribute('rel', 'apple-touch-icon');
    document.head.appendChild(link2);
    link3.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_152x152.png'
    );
    link3.setAttribute('rel', 'apple-touch-icon');
    link3.setAttribute('sizes', '152x152');
    document.head.appendChild(link3);
    link4.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_167x167.png'
    );
    link4.setAttribute('rel', 'apple-touch-icon');
    link4.setAttribute('sizes', '167x167');
    document.head.appendChild(link4);
    link5.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_180x180.png'
    );
    link5.setAttribute('rel', 'apple-touch-icon');
    link5.setAttribute('sizes', '180x180');
    document.head.appendChild(link5);
    link6.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_192x192.png'
    );
    link6.setAttribute('rel', 'icon');
    link6.setAttribute('sizes', '192x192');
    document.head.appendChild(link6);
    link7.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_128x128.png'
    );
    link7.setAttribute('rel', 'icon');
    link7.setAttribute('sizes', '128x128');
    document.head.appendChild(link7);
    link8.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_180x180.png'
    );
    link8.setAttribute('rel', 'apple-touch-startup-image');
    document.head.appendChild(link8);
  }

  private loadTheme() {
    // let theme = 'theme_' + localStorage.getItem('ThemeImg');
    let theme = 'theme_TR';
    document.querySelector('html').classList.add(theme);
  }

  private changeCssColorVar() {
    //Principal Colors
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-01',
        AppConfig.cssVars.colors.principalColors[0]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-02',
        AppConfig.cssVars.colors.principalColors[1]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-03',
        AppConfig.cssVars.colors.principalColors[2]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-04',
        AppConfig.cssVars.colors.principalColors[3]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-05',
        AppConfig.cssVars.colors.principalColors[4]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-06',
        AppConfig.cssVars.colors.principalColors[5]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-07',
        AppConfig.cssVars.colors.principalColors[6]
      );

    //Color Graphic
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-00',
        AppConfig.cssVars.colors.colorGraphic[0]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-01',
        AppConfig.cssVars.colors.colorGraphic[1]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-02',
        AppConfig.cssVars.colors.colorGraphic[2]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-03',
        AppConfig.cssVars.colors.colorGraphic[3]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-04',
        AppConfig.cssVars.colors.colorGraphic[4]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-05',
        AppConfig.cssVars.colors.colorGraphic[5]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-06',
        AppConfig.cssVars.colors.colorGraphic[6]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-07',
        AppConfig.cssVars.colors.colorGraphic[7]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-08',
        AppConfig.cssVars.colors.colorGraphic[8]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-09',
        AppConfig.cssVars.colors.colorGraphic[9]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-10',
        AppConfig.cssVars.colors.colorGraphic[10]
      );

    //Color Graphic2
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-00',
        AppConfig.cssVars.colors.colorGraphic2[0]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-01',
        AppConfig.cssVars.colors.colorGraphic2[1]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-02',
        AppConfig.cssVars.colors.colorGraphic2[2]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-03',
        AppConfig.cssVars.colors.colorGraphic2[3]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-04',
        AppConfig.cssVars.colors.colorGraphic2[4]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-05',
        AppConfig.cssVars.colors.colorGraphic2[5]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-06',
        AppConfig.cssVars.colors.colorGraphic2[6]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-07',
        AppConfig.cssVars.colors.colorGraphic2[7]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-08',
        AppConfig.cssVars.colors.colorGraphic2[8]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-09',
        AppConfig.cssVars.colors.colorGraphic2[9]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-10',
        AppConfig.cssVars.colors.colorGraphic2[10]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-11',
        AppConfig.cssVars.colors.colorGraphic2[11]
      );

    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--white-color',
        AppConfig.cssVars.colors.whiteColor
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--font-color',
        AppConfig.cssVars.colors.fontColor
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--background-body-color',
        AppConfig.cssVars.colors.backgroundBodyColor
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--bto-background-color',
        AppConfig.cssVars.colors.btoBackgroundColor
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--background-headerPortfolio',
        AppConfig.cssVars.colors.backgroundHeaderPortfolio
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty('--font-base', AppConfig.cssVars.fontBase);
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--radius-box-portfolio',
        AppConfig.cssVars.radiusBoxPortfolio
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty('--radius-btn', AppConfig.cssVars.radiusBtn);
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--radius-card-white',
        AppConfig.cssVars.radiusCardWhite
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--radius-modal',
        AppConfig.cssVars.radiusModal
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--radius-pictures',
        AppConfig.cssVars.radiusPictures
      );
  }

  private shouldHideEvaOnRoute(url: string): boolean {
    const path = (url || '').split('?')[0].split('#')[0].toLowerCase();
    const isPublicRoute = this.publicRoutePrefixes.some((prefix) =>
      path.startsWith(prefix)
    );

    const token = window.localStorage
      ? window.localStorage.getItem(LocalStorageKey.SESSION_TOKEN)
      : null;
    const hasToken =
      !!token && token !== 'undefined' && token !== 'null' && token.trim() !== '';

    return isPublicRoute || !hasToken;
  }
}
